'use client'

import { useSession } from 'next-auth/react'

import { useQuery } from '@tanstack/react-query'

import type { BootstrapPayload } from './bootstrapQuery'
import { bootstrapQueryOptions } from './bootstrapQuery'

export function useBootstrap(initialData?: BootstrapPayload) {
  const { data: session } = useSession()
  const userId = session?.user?.id as string | undefined

  return useQuery({
    ...bootstrapQueryOptions(userId ?? ''),
    enabled: !!userId,
    ...(initialData !== undefined && initialData !== null
      ? { initialData }
      : {})
  })
}
